import { createAction } from "@reduxjs/toolkit";

import type { NodeAction, NodeDesignsEntity } from "../../schemas/index.ts";
import { withPayloadType } from "./actionHelpers.ts";
import type { SendServerActionInProgress } from "./nautilusState.ts";
import type { ServerAction } from "./serverActions.ts";

export type LoadPayload<AppConfig extends Record<string, unknown>> = Omit<NodeDesignsEntity, "appVersion"> & {
  appConfig: AppConfig;
};

export const revertAction = createAction("REVERT");
export const flushAction = createAction("FLUSH");
export const loadAction = createAction("LOAD", withPayloadType<LoadPayload<Record<string, unknown>>>());
export const undoAction = createAction("UNDO");
export const redoAction = createAction("REDO");

export const sendServerActionInProgressAction = createAction(
  "SEND_SERVER_ACTION_IN_PROGRESS",
  withPayloadType<SendServerActionInProgress>(),
);

export const sendServerActionCompleted = createAction("SEND_SERVER_ACTION_COMPLETED", withPayloadType<ServerAction>());

export type NautilusStateAction =
  | ReturnType<typeof flushAction>
  | ReturnType<typeof loadAction>
  | ReturnType<typeof redoAction>
  | ReturnType<typeof revertAction>
  | ReturnType<typeof sendServerActionInProgressAction>
  | ReturnType<typeof sendServerActionCompleted>
  | ReturnType<typeof undoAction>
  | NodeAction;
